export * from './IngredientCardNoticeLabel';
